import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';
import { ActiveBrandService } from '@go-modules/services/active-brand';

export interface WelcomeTourDialogData {
	dialogTitleId?: string;
}

@Component({
	selector: 'app-welcome-tour-dialog',
	templateUrl: './welcome-tour-dialog.component.html',
	styleUrls: ['./welcome-tour-dialog.component.scss'],
	standalone: false
})
export class WelcomeTourDialogComponent {

	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<WelcomeTourDialogData>
	): MatDialogRef<WelcomeTourDialogComponent, boolean | undefined> {
		const dialogTitleId = config?.data?.dialogTitleId ?? WelcomeTourDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, WelcomeTourDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `welcome-tour-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	public constructor (
		public dialogRef: MatDialogRef<WelcomeTourDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: WelcomeTourDialogData,
		private activeBrandService: ActiveBrandService
	) {
		this.data.dialogTitleId ??= WelcomeTourDialogComponent.getDialogTitleId();
	}

	public get translationParams () {
		return this.activeBrandService.getTranslationParams();
	}

	public close () {
		this.dialogRef.close();
	}

	public startTour () {
		this.dialogRef.close(true);
	}
}
